import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { invokeMqq, MqqErrorName, MqqNamespace } from "../data-source/mqq";
/**
 * 在本机文件系统中删除本地文件（需在腾讯文档桌面端 2.3.25+ 版本中才能运行）
 */
export function deleteLocalFile(params) {
  return new DeleteLocalFileRequest(params).send();
}
export var DeleteLocalFileRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(DeleteLocalFileRequest, _DriveRequest);
  var _super = _createSuper(DeleteLocalFileRequest);
  function DeleteLocalFileRequest() {
    _classCallCheck(this, DeleteLocalFileRequest);
    return _super.apply(this, arguments);
  }
  _createClass(DeleteLocalFileRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return invokeMqq(payload);
            case 2:
              data = _context.sent;
              if (!data.err) {
                _context.next = 5;
                break;
              }
              throw new DriveApiError({
                name: MqqErrorName.UnknownMqqError,
                message: data.err,
                params: this.params,
                payload: payload,
                response: data.data
              });
            case 5:
              return _context.abrupt("return", data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        namespace: MqqNamespace.Docx,
        methodName: 'deleteLocalFile',
        data: {
          path: params.path
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.err) {
        throw new DriveApiError({
          name: 'DeleteLocalFileResponseError',
          message: response.err,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return;
    }
  }]);
  return DeleteLocalFileRequest;
}(DriveRequest);
//# sourceMappingURL=delete-local-file.js.map